const DATABASE = 'adenrel-place-tree-backups';
const STORE = 'drafts';

export const createPlaceTreeBackupStore = (getFactory = () => window.indexedDB) => {
  const run = (mode, operation) => new Promise((resolve, reject) => {
    const factory = getFactory();
    if (!factory) { reject(new Error('Large draft storage is unavailable.')); return; }
    const request = factory.open(DATABASE, 1);
    request.onupgradeneeded = () => {
      if (!request.result.objectStoreNames.contains(STORE)) request.result.createObjectStore(STORE);
    };
    request.onerror = () => reject(request.error || new Error('Could not open draft storage.'));
    request.onblocked = () => reject(new Error('Draft storage is blocked by another browser tab.'));
    request.onsuccess = () => {
      const db = request.result;
      try {
        const transaction = db.transaction(STORE, mode);
        const operationRequest = operation(transaction.objectStore(STORE));
        transaction.oncomplete = () => { db.close(); resolve(operationRequest.result); };
        transaction.onabort = () => { db.close(); reject(transaction.error || new Error('Draft backup transaction failed.')); };
        transaction.onerror = () => {}; // onabort reports the transaction failure.
      } catch (error) { db.close(); reject(error); }
    };
  });
  return {
    write: (id, snapshot) => run('readwrite', store => store.put(snapshot, id)),
    read: id => run('readonly', store => store.get(id)),
    list: () => run('readonly', store => store.getAllKeys()),
    remove: id => run('readwrite', store => store.delete(id)),
    clear: () => run('readwrite', store => store.clear()),
  };
};

export const placeTreeBackupStore = createPlaceTreeBackupStore();
